export default {
  tasksReward: 'Tasks Reward',
  lastWeekReward: 'Last Week Reward',
  thisWeekReward: 'This Week Reward',
};
